module.exports = __webpack_public_path__ + "img/bottom-right.86048d7c.svg";